import type { Time } from "@adrekic/fieldsjson"
import { Popover, stopPropagation } from "@overmap-ai/blocks"
import { TimeFieldControl } from "@overmap-ai/forms"
import { type ComponentPropsWithoutRef, memo } from "react"

interface TimePickerPopoverProps
	extends ComponentPropsWithoutRef<typeof Popover.Root>, ComponentPropsWithoutRef<typeof Popover.Content> {
	value?: Time | null
	onValueChange: (value: Time | null) => void
}

export const TimePickerPopover = memo<TimePickerPopoverProps>((props) => {
	const {
		children,
		open,
		onOpenChange,
		defaultOpen,
		modal,
		size = "sm",
		accentColor = "base",
		value,
		onValueChange,
		...rest
	} = props

	return (
		<Popover.Root open={open} onOpenChange={onOpenChange} defaultOpen={defaultOpen} modal={modal}>
			<Popover.Trigger asChild>{children}</Popover.Trigger>
			<Popover.Content size={size} accentColor={accentColor} onClick={stopPropagation} {...rest}>
				<TimeFieldControl compact size={size} value={value} onChange={onValueChange} />
			</Popover.Content>
		</Popover.Root>
	)
})
TimePickerPopover.displayName = "TimePickerPopover"
